<template>
  <div
    class="txt-pin"
    :class="mixClasses"
  >
    <div class="pin-placeholder">
      <div
        :class="pinClass"
      >
        <i
          class="fa fa-thumb-tack"
          aria-hidden="true"
        />
      </div>
    </div>
    <div>{{ text }}</div>
  </div>
</template>

<script>
import KeyMirror from 'keymirror'
import { computed } from 'vue-demi'

export const PIN_COLORS = KeyMirror({
  ORANGE: null,
  DOT_GREEN: null,
})

const pinColorsMapping = {
  [PIN_COLORS.ORANGE]: 'pin__orange',
  [PIN_COLORS.DOT_GREEN]: 'pin__dot-green',
}

export default {
  props: {
    text: {
      type: String,
      default: () => '',
    },
    color: {
      type: String,
      default: PIN_COLORS.ORANGE,
      validator: (val) => {
        const validColors = Object.keys(PIN_COLORS)
        return validColors.includes(val)
      },
    },
    rtl: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    return {
      mixClasses: computed(() => [
        props.rtl && 'reverse',
        props.inline && 'inline',
      ]),
      pinClass: computed(() => {
        return pinColorsMapping[props.color]
      }),
    }
  },
}
</script>

<style lang="scss" scoped>
.pin {
  &-placeholder {
    width: 28px;
    height: 14px;
    display: inline-block;
    position: relative;
    margin-right: 10px;
    flex-shrink: 0;
  }
  &__dot-green {
    top: -2px;
    right: 0px;
    z-index: 99;
    position: absolute;
    background: green;
    width: 8px;
    height: 8px;
    border-radius: 4px;
  }
  &__orange {
    vertical-align: middle;
    position: relative;
    background-color: #e69500;
    border-radius: 7px;
    text-align: center;
    width: 100%;
    height: 100%;
    i {
      position: absolute;
      top: 2px;
      left: 10px;
      transform: rotate(45deg);
      font-size: 12px;
      color: white;
    }
  }
}

.txt-pin {
  display: flex;
  align-items: center;
  &.non-margin {
    .pin-placeholder {
      margin: 0
    }
  }
  &.inline {
    display: inline-flex;
  }
  &.reverse {
    flex-direction: row-reverse;
    justify-content: flex-end;
    .pin-placeholder {
      margin-right: 0;
      margin-left: 5px;
    }
  }
}

</style>
